/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

export default class IndexRoute extends Route {
  // Services
  @service
  store;

  model() {
    let params = this.paramsFor('admin.people.schema');
    return this.store.query('people-schema/group', {
      personType: params.personType,
    });
  }

  setupController(controller) {
    super.setupController(...arguments);

    // Push personType query param from parent route into this route's controller.
    let parentParams = this.paramsFor('admin.people.schema');
    controller.set('personType', parentParams.personType);
  }
}
